import { useAppDispatch, useAppSelector } from '../../app/hooks'
import CloseIcon from '@mui/icons-material/Close'
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  Suspense,
} from 'react'
import { startSxpProxy } from '../../utils/api'
import {
  // CHAT_PROJECT_ID,
  // IPD_PROJECT_ID,
  // LABS_PROJECT_ID,
  OPD_PROJECT_ID,
  // REGISTRATION_PROJECT_ID,
} from '../../utils/constants'
import OPDVisitCreateDialog from '../OPDScreen/OPDVisitCreateDialog'
import { intent } from '../Radiology/Constants/constants'
import { setOpdPatientData } from '../opd/OpdPatientSlice'
import { upComingAppointmentType } from '../OPDScreen/Utils'
import { makeName } from '../lms/utils'
import { STATUS_DISPLAY_TEXT, VISIT_STATUS, AppRoutes } from './Constants'
import {
  TableCell,
  TableRow,
  Typography,
  Button,
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  IconButton,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
} from '@mui/material'
import { makeStyles } from '../../utils/hooks/makeStyles'

// Helper function to format patient name from FHIR Patient resource
const useStyles = makeStyles(() => ({
  doctorWrapper: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  selectMinWidth: {
    minWidth: 200,
  },
}))

const formatPatientName = (patient: any) => {
  if (!patient || !patient?.name || !Array.isArray(patient?.name)) return '-'

  const officialName =
    patient?.name?.find((n: any) => n?.use === 'official') || patient?.name?.[0]
  if (!officialName) return '-'

  return (
    [
      ...(officialName?.prefix || []),
      ...(officialName?.given || []),
      officialName?.family,
    ]
      .filter(Boolean)
      .join(' ')
      .trim() || '-'
  )
}
// import {
//   downloadDocumentFromDMSById,
//   getDocumentIdFromHasura,
// } from '../../services/OpdFormsSTTService'
// import { toast } from 'react-toastify'
import {
  // campVisitCreate,
  getAllCampAppointments,
  getDoctors,
  UpdateCampVisitDoctorApi,
} from '../../services/CampManagementService'
import { MemoryRouter, Routes, Route } from 'react-router-dom'
import styles from './visitDashboard.module.scss'
import { createRoot, Root } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from '../../app/store'
// import Vitals from '../opd/components/Vitals'
import History from '../opd/components/History'
import Systemic from '../opd/components/Systemic'
import Diagnosis from '../opd/components/Diagnosis'
import Medications from '../opd/components/medications/Medications'
// import OpdOrder from '../labTests/OPDOrders'
// import Devices from '../opd/components/devices/Devices'
import TreatmentPlanPhysio from '../opd/components/TreatmentPlanPhysio'
import Opd from '../opd/Opd'
// import RadiologyOrder from '../Radiology/components/search/RadiologyOrder'
const CancerScreening = React.lazy(
  () => import('../opd/components/CancerScreening/CancerScreening')
)
import Loading from '../../form/fields/Loading'
// TreatmentPlanCodes import removed as it's unused
import { visitDashboardConstants } from '../campManagement/constants/Constants'
import DoctorReview from '../campManagement/component/DoctorReview'
import { toast } from 'react-toastify'
import ChiefComplaintsComponent from '../campManagement/component/ChiefComplaints'
import PastMedicalHistoryComponent from '../campManagement/component/PastMedicalHistory'
import CampPatientVitalsComponent from '../campManagement/component/CampPatientVitals'
import FileUploadWithOptions from '../campManagement/component/FileUploadWithOptions'
import ENTScreening from '../campManagement/component/ENTScreening'
import OpthmologyScreening from '../campManagement/component/OpthmologyScreening'
import OpdDevices from './OpdDevices'
import HealthGrade from './HealthGrade'
import DentalClinicalExamination from './DentalClinicalExamination'
// import CreateLabOrder from './lab/CreateLabOrder'

// interface Appointment {
//   appointmentId: string
// }

// export const getStatusColor = (status: string) => {
//   if (!status) return '#9e9e9e'
//   switch (status.toLowerCase()) {
//     case 'completed':
//       return '#4caf50'
//     case 'cancelled':
//       return '#f44336'
//     case 'in progress':
//       return '#2196f3'
//     case 'scheduled':
//       return '#ff9800'
//     default:
//       return '#9e9e9f'
//   }
// }

interface AppointmentRowProps {
  appointment: any
  onViewClick: (appointment: any) => void
  styles: any
  isSelected?: boolean
}

interface NoAppointmentsRowProps {
  styles: any
}

const AppointmentRow: React.FC<AppointmentRowProps> = ({
  appointment,
  onViewClick,
  styles,
  isSelected = false,
}) => {
  const handleClick = () => {
    onViewClick(appointment)
  }

  return (
    <TableRow
      hover
      className={`${styles?.tableRow} ${isSelected ? styles.selectedRow : ''}`}
    >
      <TableCell className={styles?.tableCell}>
        {appointment?.appointmentId || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.visitId || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.uhid || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.name || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.mobile || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.speciality || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.visitingDoctorName || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        {appointment?.visitType || '-'}
      </TableCell>
      <TableCell className={styles?.tableCell}>
        <span
          className={`${styles.statusBadge} ${
            styles[
              `status-${
                appointment?.visitStatus?.toLowerCase() || VISIT_STATUS.PLANNED
              }`
            ]
          }`}
        >
          {STATUS_DISPLAY_TEXT[
            appointment?.visitStatus?.toLowerCase() as keyof typeof STATUS_DISPLAY_TEXT
          ] || STATUS_DISPLAY_TEXT[VISIT_STATUS.PLANNED]}
        </span>
      </TableCell>
      <TableCell className={styles?.actionCell}>
        <Button
          variant='contained'
          color='primary'
          size='small'
          onClick={handleClick}
        >
          View
        </Button>
      </TableCell>
    </TableRow>
  )
}

const NoAppointmentsRow: React.FC<NoAppointmentsRowProps> = ({ styles }) => (
  <TableRow>
    <TableCell colSpan={9} className={styles?.noAppointmentsCell}>
      <Typography color='textSecondary'>No appointments found</Typography>
    </TableCell>
  </TableRow>
)

const OPDVisits = ({
  id,
  campDetails,
  patientDetails,
}: {
  id: string
  campDetails: any
  patientDetails: any
}) => {
  const classes = useStyles()
  const [showPatientDetails, setShowPatientDetails] = useState(false)
  const [patientData, setPatientData] = useState<any>(null)
  const [doctors, setDoctors] = useState<any[]>([])
  const [selectedDoctorId, setSelectedDoctorId] = useState<any>({})
  const [appointmentData, setAppointmentData] = useState<any>({})

  // Helper function to calculate age from birth date
  const calculateAge = (birthDate: string): string => {
    const today = new Date()
    const birthDateObj = new Date(birthDate)

    if (isNaN(birthDateObj.getTime())) {
      return '-'
    }

    let age = today.getFullYear() - birthDateObj.getFullYear()
    const monthDiff = today.getMonth() - birthDateObj.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--
    }

    return `${age} years`
  }

  const [upcomingAppointments, setUpcomingAppointments] = useState<
    upComingAppointmentType[]
  >([])
  const [appointmentId, setAppointmentId] = useState<string>('')
  const [show, setShow] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [patientUhid, setPatientUhid] = useState<string>('')
  const dispatch = useAppDispatch()
  const handleRefresh = () => {
    setRefresh(true)
  }

  // const navigate = useNavigate()

  const selectedCamp =
    useAppSelector((state) => state?.campManagement?.selectedCamp) ||
    campDetails

  const [showInlineOpd, setShowInlineOpd] = useState(false)
  const [selectedAppointmentId, setSelectedAppointmentId] = useState<
    string | null
  >(null)
  const inlineContainerRef = useRef<HTMLDivElement | null>(null)
  const inlineRootRef = useRef<Root | null>(null)

  const fetchAllVisits = useCallback(
    async (patientID: any) => {
      try {
        const resp = await getAllCampAppointments(
          selectedCamp?.campId,
          patientID
        )
        setUpcomingAppointments(resp?.data || [])
      } catch (e) {
        toast.error(`Error fetching visits: ${e}`)
        setUpcomingAppointments([])
      }
    },
    [selectedCamp?.campId]
  )
  // Initialize appointment and fetch visits
  const initializeAppointmentAndFetchVisits = useCallback(() => {
    setAppointmentId('appt-' + Math?.random()?.toString(36)?.substr(2, 9))
    if (id) {
      fetchAllVisits(id)
    }
  }, [id, fetchAllVisits])

  // Fetch visits when component mounts or patient ID changes
  useEffect(() => {
    initializeAppointmentAndFetchVisits()
  }, [initializeAppointmentAndFetchVisits])

  const cleanupInlineRoot = useCallback(() => {
    if (inlineRootRef?.current && inlineContainerRef?.current) {
      try {
        // Clear the container first
        const container = inlineContainerRef.current
        if (container && container.childNodes.length > 0) {
          inlineRootRef.current.unmount()
        }
      } catch (e) {
        console.error('Error during cleanup:', e)
      } finally {
        inlineRootRef.current = null
      }
    }
  }, [])

  useEffect(() => {
    return cleanupInlineRoot
  }, [cleanupInlineRoot])

  const fetchData = useCallback(async (patientId: string) => {
    try {
      const patientIntent = intent?.getPatientApi
      const state = { id: patientId }
      const resp = await startSxpProxy(OPD_PROJECT_ID, patientIntent, state)
      setPatientData(resp?.data)
      const patientUhid = resp?.data?.identifier?.find(
        (id: any) =>
          id?.system === visitDashboardConstants?.defaults?.patientIdentifier
      )?.value
      setPatientUhid(patientUhid)
      // await fetchAllAppointments(patientId)
      // await fetchLabOrders(patientId)
      await fetchAllVisits(patientUhid)
    } catch (e) {
      toast.error(`Error fetching data: ${e}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    fetchData(id)
  }, [id, fetchData])

  // Reset showInlineOpd when patient changes
  useEffect(() => {
    setShowInlineOpd(false)
  }, [id])

  // Reset appointmentData when patient or camp changes
  useEffect(() => {
    setAppointmentData({})
    setSelectedAppointmentId(null)
    setShowPatientDetails(false)
  }, [id, selectedCamp?.campId])

  const mountInlineRouter = (
    encId: string,
    patientId?: string,
    initialPath = `/visits/${encId}/campPatientVitals`,
    appointmentDataParam?: any
  ) => {
    const container = inlineContainerRef?.current
    if (!container) return

    // Use passed appointmentData or fall back to component state
    const currentAppointmentData = appointmentDataParam || appointmentData

    // Get the patient data from the component's state
    const patientDataToPass = {
      id: patientId,
      fhirId: patientId,
      name: patientData?.name || '',
      identifier: patientData?.identifier || [],
      telecom: patientData?.telecom || [],
    }

    // unmount previous if exists
    if (inlineRootRef.current) {
      try {
        if (container && container.childNodes.length > 0) {
          inlineRootRef.current.unmount()
        }
      } catch (e) {
        console.error('Error unmounting previous root:', e)
      } finally {
        inlineRootRef.current = null
      }
    }

    // Clear container before creating new root
    if (container) {
      container.innerHTML = ''
    }

    const root = createRoot(container)
    inlineRootRef.current = root
    root.render(
      <Provider store={store}>
        <MemoryRouter
          initialEntries={[
            {
              pathname: initialPath,
              state: {
                id: patientId,
                show: true,
                isCamp: true,
                patientData: patientDataToPass,
              },
            },
          ]}
        >
          <Routes>
            <Route path='/visits/:id' element={<Opd />}>
              <Route
                path='campPatientVitals'
                element={
                  <CampPatientVitalsComponent
                    intent='view'
                    appointmentData={{
                      visitId: encId,
                      uhid:
                        patientData?.identifier?.find(
                          (id: any) =>
                            id?.system ===
                            visitDashboardConstants?.defaults?.patientIdentifier
                        )?.value || patientData?.id,
                      campId: selectedCamp?.campId,
                    }}
                    patientData={patientDetails}
                    selectedVisit={currentAppointmentData}
                    // patientId={patientId} // Pass patientId as a prop
                  />
                }
              />
              {/* <Route path='vitals' element={<Vitals />} /> */}
              <Route path='history' element={<History />} />
              <Route path='systemic' element={<Systemic />} />
              <Route path='diagnosis' element={<Diagnosis />} />
              <Route path='treatmentPhysio' element={<TreatmentPlanPhysio />} />
              <Route path='medications' element={<Medications />} />

              <Route
                path='devices'
                element={
                  <OpdDevices
                    appointmentData={{
                      ...currentAppointmentData,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              {/* <Route
                path='radiology-orders'
                element={
                  <RadiologyOrder modeType={'visit'} originMode={'OPD'} />
                }
              /> */}
              <Route
                path='cancerScreening'
                element={
                  <Suspense fallback={<Loading />}>
                    <CancerScreening />
                  </Suspense>
                }
              />
              <Route
                path='doctorReview'
                element={<DoctorReview camp={campDetails} visitId={encId} />}
              />
              <Route
                path='chiefComplaints'
                element={
                  <ChiefComplaintsComponent
                    appointmentData={{
                      visitId: encId,
                      uhid:
                        patientData?.identifier?.find(
                          (id: any) =>
                            id?.system ===
                            visitDashboardConstants?.defaults?.patientIdentifier
                        )?.value || patientData?.id,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              <Route
                path='pastMedicalHistory'
                element={
                  <PastMedicalHistoryComponent
                    appointmentData={{
                      visitId: encId,
                      uhid:
                        patientData?.identifier?.find(
                          (id: any) =>
                            id?.system ===
                            visitDashboardConstants?.defaults?.patientIdentifier
                        )?.value || patientData?.id,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              <Route
                path='entscreening'
                element={
                  <ENTScreening
                    appointmentData={{
                      ...currentAppointmentData,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              <Route
                path='healthgrading'
                element={
                  <HealthGrade
                    appointmentData={{
                      ...currentAppointmentData,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              <Route
                path='opthmologyScreening'
                element={
                  <OpthmologyScreening
                    appointmentData={{
                      ...currentAppointmentData,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              <Route
                path='dentalclinicalcxamination'
                element={
                  <DentalClinicalExamination
                    appointmentData={{
                      ...currentAppointmentData,
                      campId: selectedCamp?.campId,
                    }}
                  />
                }
              />
              <Route
                path='documentUpload'
                element={
                  <FileUploadWithOptions
                    patientUhid={patientUhid}
                    visitId={encId}
                  />
                }
              />
            </Route>
          </Routes>
        </MemoryRouter>
      </Provider>
    )
  }

  // handleCreateVisitClick function removed as it was unused

  const handleViewButtonClick = (appointment: any) => {
    setAppointmentData(appointment)
    setSelectedAppointmentId(appointment?.appointmentId)
    setShowPatientDetails(true)

    // Fetch doctors for the appointment's speciality
    if (appointment?.speciality) {
      getDoctorBySpecilization(
        appointment.speciality,
        appointment.visitingDoctorId
      )
    }

    // Create a complete patient data object with all required fields
    const patientData = {
      id: id, // Use the FHIR patient ID from component prop
      patientId: id, // Use the FHIR patient ID from component prop
      patientName: appointment?.name, // Using name as patientName
      name: appointment?.name ? [{ given: [appointment?.name] }] : undefined,
      // Add other required fields that the OPD screen expects
      muhId: appointment?.uhid, // Using uhid as muhId (business identifier)
      visitStatus: VISIT_STATUS.IN_PROGRESS, // Default status
      visitType:
        appointment?.speciality?.toLowerCase() ===
        AppRoutes?.ONCOLOGY?.toLowerCase()
          ? 'cancerscreening'
          : 'OPD', // Default visit type
      encounterId: appointment?.visitId,
      fhirId: id, // Use the FHIR patient ID from component prop
      telecom: [
        {
          system: 'phone',
          value: appointment?.mobile,
          use: 'mobile',
        },
      ],
      // Add any existing patient data
      ...appointment,
    }
    // Call showvisit with all required parameters including patient data
    showVisit(
      id, // Use FHIR patient ID instead of uhid
      appointment?.visitId, // encounterId
      VISIT_STATUS.IN_PROGRESS, // Default status
      appointment?.speciality?.toLowerCase() === AppRoutes?.ONCOLOGY
        ? 'cancerscreening'
        : 'OPD', // Default visit type
      patientData
    )
  }

  const showVisit = (
    patientId: string,
    encounterId: string,
    visitStatus: string,
    encounterVisitType: any,
    patientDataParam: any = {}
  ) => {
    // Use the passed patientData or fall back to the component's patientData
    const patientDataToPass =
      Object.keys(patientDataParam).length > 0
        ? patientDataParam
        : patientData || { id: patientId }

    dispatch(
      setOpdPatientData({
        ...patientDataToPass,
        id: patientId,
        muhId: patientDataToPass?.muhId || patientId,
        visitStatus: visitStatus || VISIT_STATUS.PLANNED,
        visitType: encounterVisitType,
        PatientNumber:
          patientDataToPass?.telecom?.find(
            (e: any) => e?.use === visitDashboardConstants?.defaults?.mobile
          )?.value || '',
        patientName:
          patientDataToPass?.patientName || makeName(patientDataToPass?.name),
        patientId: patientId,
        // include encounterId so other components (e.g. OpdMenu) can build absolute visit routes
        encounterId: encounterId,
        visitId: encounterId,
        fhirId: patientId,
        gender: patientDataToPass?.gender,
        birthDate: patientDataToPass?.birthDate,
        telecom: patientDataToPass?.telecom,
        address: patientDataToPass?.address,
        identifier: patientDataToPass?.identifier,
      })
    )
    setShowInlineOpd(true)
    setTimeout(
      () =>
        mountInlineRouter(encounterId, patientId, undefined, patientDataParam),
      50
    )
    setTimeout(() => {
      const el = document?.getElementById('camp-inline-container')
      if (el) el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 100)
  }

  const VisitTableRef = useRef<HTMLDivElement | null>(null)

  const resizeHandler = useCallback(() => {
    const container = VisitTableRef?.current
    if (container) {
      const availableHeight =
        window?.innerHeight - container?.getBoundingClientRect()?.top
      container.style.maxHeight = `${availableHeight - 200}px`
    }
  }, [])

  useEffect(() => {
    window?.addEventListener('resize', resizeHandler)
    resizeHandler()
    // fetchLabOrders(id)
    return () => {
      window?.removeEventListener('resize', resizeHandler)
    }
  }, [
    dispatch,
    resizeHandler,
    id,
    // fetchLabOrders
  ])

  useEffect(() => {
    if (refresh === true) {
      fetchData(id)
    }
  }, [refresh, id, fetchData])

  const getDoctorBySpecilization = useCallback(
    async (speciality: string, currentDoctorId?: string) => {
      const response = await getDoctors(speciality)
      if (response?.success) {
        // Get all doctors for the selected specialization
        const filteredDoctors = response?.data || []
        setDoctors(filteredDoctors)

        // If there's a current doctor ID, find and set it
        if (currentDoctorId) {
          const currentDoctor = filteredDoctors.find(
            (doc: any) => doc.practitionerId === currentDoctorId
          )
          if (currentDoctor) {
            setSelectedDoctorId(currentDoctor)
          }
        }
        // setSpecializationDoctors(
        //   (
        //     prev: Array<{
        //       id: string
        //       specialization: string
        //       specializationDisplay: string
        //       doctor: string
        //       doctorsList?: Array<{
        //         practitionerId: string
        //         displayName: string
        //         practitionerRoleId: string
        //         speciality: string
        //       }>
        //       openToMaleAppointment: boolean
        //       openToFemaleAppointment: boolean
        //       active?: boolean
        //       isNew?: boolean
        //     }>
        //   ) =>
        //     prev?.map((item) =>
        //       item?.id === id
        //         ? {
        //             ...item,
        //             doctorsList: filteredDoctors,
        //           }
        //         : item
        //     )
        // )
      } else {
        toast.error(response?.message || 'Failed to load doctors')
      }
    },
    []
  )

  const handleDoctorAssignment = async () => {
    const selectedDoctor = doctors.find(
      (d) => d.practitionerId === selectedDoctorId?.practitionerId
    )

    if (!selectedDoctor) {
      toast.error('Please select a doctor')
      return
    }

    const selectedAppointment: any = upcomingAppointments.find(
      (apt: any) => apt.appointmentId === selectedAppointmentId
    )

    if (!selectedAppointment) {
      toast.error('Appointment not found')
      return
    }

    try {
      const payload = {
        visitId: selectedAppointment.visitId,
        visitingDoctorId: selectedDoctor.practitionerId,
        visitingDoctorName: selectedDoctor.displayName,
        visitingDoctorSpeciality: selectedDoctor.speciality,
      }

      const res = await UpdateCampVisitDoctorApi(payload)
      if (res.success) {
        toast.success(
          `Doctor ${selectedDoctor.displayName} assigned successfully`
        )

        // Update the appointments list with the new doctor info
        setUpcomingAppointments((prevAppointments) =>
          prevAppointments.map((apt: any) =>
            apt.appointmentId === selectedAppointmentId
              ? {
                  ...apt,
                  visitingDoctorId: selectedDoctor.practitionerId,
                  visitingDoctorName: selectedDoctor.displayName,
                }
              : apt
          )
        )

        // Update appointmentData with the new doctor info
        const updatedAppointmentData = {
          ...appointmentData,
          visitingDoctorId: selectedDoctor.practitionerId,
          visitingDoctorName: selectedDoctor.displayName,
        }

        setAppointmentData(updatedAppointmentData)

        // Call handleViewButtonClick with updated data
        handleViewButtonClick(updatedAppointmentData)

        // Update patientData with the new doctor info
        setPatientData((prevData: any) => ({
          ...prevData,
          visitingDoctorId: selectedDoctor.practitionerId,
          visitingDoctorName: selectedDoctor.displayName,
        }))

        // Optionally fetch all visits to ensure sync
        await fetchAllVisits(patientUhid)
        setSelectedDoctorId({})
      } else {
        toast.error(res?.message || 'Failed to assign doctor')
      }
    } catch (error) {
      console.error('Error assigning doctor:', error)
      toast.error('Failed to assign doctor')
    }
  }

  const patientMUHId = patientData?.identifier?.[2]?.value

  const handleCrossIconClick = (e: React.MouseEvent) => {
    e?.stopPropagation()
    togglePatientDetails()
  }
  const togglePatientDetails = () => {
    setShowPatientDetails(!showPatientDetails)
  }

  return (
    <>
      {show && (
        <Dialog
          open={show}
          onClose={() => setShow(false)}
          maxWidth='md'
          fullWidth={true}
          className={styles?.dialog}
        >
          <div
            className={styles?.dialogCloseButton}
            onClick={handleCrossIconClick}
            title='Patient details'
          >
            <CloseIcon />
          </div>
          <div className={styles?.dialogContentWrapper}>
            <DialogTitle className={styles?.dialogTitle}>
              Visit&nbsp;Creation ({patientMUHId})
            </DialogTitle>
            <OPDVisitCreateDialog
              patientId={id}
              appointmentId={appointmentId}
              onRefresh={handleRefresh}
              onClose={() => setShow(false)}
            />
          </div>
        </Dialog>
      )}

      <Box className={styles?.container}>
        <Typography variant='h6' className={styles?.sectionTitle}>
          Appointments
        </Typography>
        <TableContainer component={Paper} className={styles?.tableContainer}>
          <Table
            size='small'
            aria-label='appointments table'
            className={styles?.table}
          >
            <TableHead>
              <TableRow className={styles?.tableHeaderRow}>
                <TableCell className={styles?.headerCell}>
                  Appointment ID
                </TableCell>
                <TableCell className={styles?.headerCell}>Visit ID</TableCell>
                <TableCell className={styles?.headerCell}>UHID</TableCell>
                <TableCell className={styles?.headerCell}>Name</TableCell>
                <TableCell className={styles?.headerCell}>Mobile</TableCell>
                <TableCell className={styles?.headerCell}>Specialty</TableCell>
                <TableCell className={styles?.headerCell}>
                  Doctor Name
                </TableCell>
                <TableCell className={styles?.headerCell}>Type</TableCell>
                <TableCell className={styles?.headerCell}>Status</TableCell>
                <TableCell className={styles?.headerCell}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {upcomingAppointments?.length > 0 ? (
                upcomingAppointments?.map((appointment: any, index: number) => (
                  <AppointmentRow
                    key={index}
                    appointment={appointment}
                    onViewClick={handleViewButtonClick}
                    styles={styles}
                    isSelected={
                      selectedAppointmentId === appointment?.appointmentId
                    }
                  />
                ))
              ) : (
                <NoAppointmentsRow styles={styles} />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {showInlineOpd && (
        <div id='camp-inline-container' className='camp-inline-wrapper'>
          <Box display='flex' justifyContent='space-between' width='100%'>
            <Typography fontSize={18} fontWeight={'bold'}>
              Clinical Data
            </Typography>
            <IconButton
              aria-label='close-camp-view'
              onClick={() => {
                setShowInlineOpd(false)
              }}
              className='close-button'
            >
              <CloseIcon />
            </IconButton>
          </Box>
          {showPatientDetails && (
            <Box className={styles?.patientDetailsBox}>
              <TableContainer
                component={Paper}
                className={styles?.tableContainer}
              >
                <Table
                  size='small'
                  aria-label='patient details table'
                  className={styles?.table}
                >
                  <TableHead>
                    <TableRow className={styles?.tableHeaderRow}>
                      <TableCell className={styles?.headerCell}>UHID</TableCell>
                      <TableCell className={styles?.headerCell}>Name</TableCell>
                      <TableCell className={styles?.headerCell}>
                        Mobile
                      </TableCell>
                      <TableCell className={styles?.headerCell}>Age</TableCell>
                      <TableCell className={styles?.headerCell}>
                        Doctor Name
                      </TableCell>
                      <TableCell className={styles?.headerCell}>
                        Gender
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        {patientData?.identifier?.[2]?.value || '-'}
                      </TableCell>
                      <TableCell>{formatPatientName(patientData)}</TableCell>
                      <TableCell>
                        {patientData?.telecom?.[0]?.value || '-'}
                      </TableCell>
                      <TableCell>
                        {patientData?.birthDate
                          ? calculateAge(patientData.birthDate)
                          : '-'}
                      </TableCell>
                      <TableCell>
                        <Box className={classes.doctorWrapper}>
                          <Select
                            value={
                              selectedDoctorId?.practitionerId ||
                              patientData?.visitingDoctorId ||
                              ''
                            }
                            onChange={(e) => {
                              const doctor = doctors.find(
                                (d) => d.practitionerId === e.target.value
                              )
                              setSelectedDoctorId(doctor || {})
                            }}
                            displayEmpty
                            size='small'
                            className={classes.selectMinWidth}
                          >
                            <MenuItem value=''>
                              <em>Select Doctor</em>
                            </MenuItem>
                            {doctors?.map((doctor) => (
                              <MenuItem
                                key={doctor?.practitionerId}
                                value={doctor?.practitionerId}
                              >
                                {doctor?.displayName}
                              </MenuItem>
                            ))}
                          </Select>
                          <Button
                            variant='contained'
                            color='success'
                            size='small'
                            disabled={!selectedDoctorId}
                            onClick={handleDoctorAssignment}
                          >
                            Save
                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {patientData?.gender
                          ? patientData?.gender.charAt(0).toUpperCase() +
                            patientData?.gender.slice(1)
                          : '-'}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {/* container where the isolated MemoryRouter root will mount */}
          {appointmentData?.visitingDoctorId ? (
            <div
              id='opd-inline-root'
              ref={inlineContainerRef}
              className='inline-root'
            />
          ) : (
            <div>Update doctor to view visits details</div>
          )}
        </div>
      )}
    </>
  )
}

export default OPDVisits
